<template>
	<div>
		<!-- start TL Search form script -->
		<div id="block-search">
			<div id="tl-search-form" class="tl-container">
				<a href="#" rel="nofollow" target="_blank">&nbsp;</a>
			</div>
		</div>
		<!-- end TL Search form script -->
	</div>
</template>

<script>

export default {
	mounted() {
		const script = document.createElement('script');
		script.src = '/tl_integration.js';
		script.async = true;
		document.head.appendChild(script);
	},
	beforeUnmount() {
		console.log('beforeUnmount:');
		const scripts = Array.from(document.querySelectorAll('script[src="/tl_integration.js"]'));
		console.log('scripts:', scripts);
		scripts.forEach(s => s.remove());
	},
	name: "TravelLineSearchFormComponent",
}
</script>

<style>
/*<!-- start TL Search form script -->*/
#block-search,
#block-search * {
	box-sizing: border-box;
}

#block-search {
	max-width: 967px;
	width: 80%;
	margin: 0 auto;
}

.tl-container {
	background: #242424;
	border-radius: 8px;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
}
/*<!-- end TL Search form script -->*/
</style>